
import "./agent.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

import { db, auth } from "../../services/firebaseConnection";
import { collection, doc, addDoc, getDoc, getDocs,  where, query,  orderBy, updateDoc, limit, setDoc, deleteDoc, runTransaction, serverTimestamp } from "firebase/firestore";

import { useForm } from "react-hook-form";

/* validação de campos */
import { masktelefone } from "../../services/masks/masks.ts";

/* navegação */
import { useNavigate, useLocation } from "react-router-dom";

/* funções auxiliares */
import { registerLog, expiryDate, formError, showError, clearError, firstName, db_basic } from "../../services/functions/functions.ts";

/* imagens */
import icon_success from "../../assets/sucesso.png";
import icon_atebreve from "../../assets/ate_breve.png";
import icon_whats from "../../assets/whats_icon.png";
import icon_web from "../../assets/web_icon.png";



export default function Agent() {

    const [basic, setBasic] = useState(null);
    const [loadBasic, setLoadBasic] = useState(true);
    
    const [error, setError] = useState("0");

    const location = useLocation();
    const [step, setStep] = useState(() => { if (typeof location.state?.step === "number") { return location.state.step; } return 0; });

    const [load, setLoad] = useState(true);
    const [loadAgent, setLoadAgent] = useState(false);

    const [plans, setPlans] = useState([]);
    const [selPlan, setSelPlan] = useState({id: 0, codigo_plano: "0", id_plano: "0"});
    const [descPlano, setDescPlano] = useState("");

    const [tel, setTel] = useState("");

    const [isUpdatePlan, setIsUpdatePlan] = useState(false);

    const [acaoPesquisa, setAcaoPesquisa] = useState("pesquisa");

    const [disponiveis, setDisponiveis] = useState(0);

    /* refs para tratamento de erros */
    const refAgente = useRef(null);
    const refLabelAgente = useRef(null);
    const refErrorAgente = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    const refErroPlano = useRef(null);

    const refPlanos = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];

    const refCheckBox = useRef(null);

    const refErroAgente = useRef(null);

    const refLoad = useRef(null);
    const refButton = useRef(null);
    const refNomeButton = useRef(null);
    const refError = useRef(null);
    /* -- */

    const { handleSubmit, register, getValues, setValue, watch } = useForm();

    const navigate = useNavigate();

    const [isPending, startTransition] = useTransition();

    const maskTelefone = watch("telefone");

    useEffect(() => { setValue("telefone", masktelefone(maskTelefone)) }, [maskTelefone]);

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);

            //carrega informações
            try {

                let plans = [];
                const sts = bbd.agent.status;

                const plansdb = collection(db, "plans");
                const plansquery = query(plansdb, where("data_termino_vigencia", "==", expiryDate()), orderBy("data_criacao", "asc"));
            
                const plansdocs = await getDocs(plansquery);

                plansdocs.forEach((doc) => {
                    plans.push({
                        id: doc.id,
                        codigo: doc.data().codigo,
                        ramo: doc.data().ramo,
                        atendimento: doc.data().atendimento,
                        valor: doc.data().valor,
                    })
                })

                setPlans([...plans]);

                //verifica qual o plano selecionado
                if(sts > 1 && sts < 5) {
                    for(let i = 0; i < plans.length; i++) {               
                        if(plans[i].codigo === bbd.agent.plano) {
                            setSelPlan({id: i + 1, codigo_plano: bbd.agent.plano, id_plano: bbd.agent.id});
                        }
                    }
                }

                if(sts === 4) {
                    setValue("agente", bbd.agent.nome);
                }

                if(sts === 0) {

                    // busca o número de agentes disponíveis para criação imediata
                    const telephonesdb = collection(db, "telephones");
                    const telephonesquery = query(telephonesdb, where("status", "==", 1));

                    const telephonesdocs = await getDocs(telephonesquery);

                    setDisponiveis(telephonesdocs.size);

                }

                if(sts === 2) {

                    const plansdb = collection(db, "plans");
                    const plansquery = query(plansdb, where("codigo", "==", bbd.agent.plano), limit(1));

                    const plansdocs = await getDocs(plansquery);

                    setDescPlano(plansdocs.docs[0].data().ramo);
                    
                }
            
            }
            catch(erro) {
                console.log(erro);
            }

            setLoadBasic(false);
        };

        loadBasic();

    }, []);


    async function create_agent(e) {

        e.preventDefault();
        formError(refError, "", false);

        let nm = getValues("agente");
        if(nm.length < 2) {
            showError(refAgente, refLabelAgente, refErrorAgente, "O nome do agente deve ter de 3 a 12 caracteres", setError, "agente");
            return;
        }

        if(selPlan.id === 0) {
            setError("plano");
            refErroPlano.current.innerHTML = "Selecione um plano para seu agente";
            refErroPlano.current.style.height = "1.5rem";
            return;
        }
        
        let uid = basic.client.id;
        let dt_atual = new Date();

        try {

            setLoadAgent(true);
            refButton.current.innerHTML = "AGUARDE ...";

            const docagent = await addDoc(collection(db, "agent"), 
            { 
                id_client: uid,
                id_plan: selPlan.id_plano,
                data_criacao: dt_atual,
                data_atualizacao: dt_atual,
                nome: nm,
                telefone: null,
                plano: selPlan.codigo_plano,
                data_inicio_ativacao: null,
                data_termino_ativacao: null,
                status: 1,
                status_motivo: null,
            })

            registerLog(uid, "/create_agent/id=" + docagent.id);

            setLoadAgent(false);

            setStep(1);
            window.scrollTo(0, 0);

        } catch(erro) {
            
            formError(refError, JSON.stringify(erro), true);
            refButton.current.innerHTML = "CRIAR AGENTE";
            setLoadAgent(false);
            
        }

    }



    async function update_agent(data) {

        formError(refError, "", false);

        let nm = getValues("agente");
        if(nm.length < 2) {
            showError(refAgente, refLabelAgente, refErrorAgente, "O nome do agente deve ter de 3 a 12 caracteres", setError, "agente");
            return;
        }

        try {

            setLoadAgent(true);
            refNomeButton.current.innerHTML = "AGUARDE ...";

            //busca id do agente gpt maker
            const usesdb = collection(db, "uses");
            const usesquery = query(usesdb, where("id_agent", "==", basic.agent.id), limit(1));
            
            const usesdocs = await getDocs(usesquery);
            const idtel = usesdocs.docs[0].data().id_telephone;

            const telephonesRef = doc(db, "telephones", idtel);
            const telephonesdoc = await getDoc(telephonesRef);
            
            const idagentgpt = await telephonesdoc.data().id_gptmaker;
            
            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/agent/updatename", { 
                method: "POST", 
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: idagentgpt,
                    name: nm
                })
            });
            
            if(resGptMaker.status !== 200) {
                formError(refError, JSON.stringify(resGptMaker.description), true);
                refNomeButton.current.innerHTML = "ALTERAR NOME";
                setLoadAgent(false);
            }
            
            //atualiza agent
            const agentRef = doc(db, "agent", basic.agent.id);

            await runTransaction(db, async (transaction) => {

                const agentSnap = await transaction.get(agentRef);

                const agentAtual = agentSnap.data();
                const agora = new Date();

                //1. salva histórico
                const histRef = doc(collection(db, "agent_hist"));

                transaction.set(histRef, {
                    ...agentAtual,
                    id_agent: basic.agent.id,
                    data_inicio_vigencia: agentAtual.data_atualizacao,
                    data_fim_vigencia: agora,
                    archived_at: serverTimestamp()
                });

                //2. atualiza documento principal
                transaction.update(agentRef, {
                    nome: nm,
                    data_atualizacao: agora
                });

            });

            refNomeButton.current.innerHTML = "ALTERAR NOME";
            setLoadAgent(false);

            registerLog(basic.client.id, "/alter_name_agent/id=" + basic.agent.id);

            setStep(4);
            window.scrollTo(0, 0);

        } catch(erro) {

            formError(refError, JSON.stringify(erro), true);
            refNomeButton.current.innerHTML = "ALTERAR NOME";
            setLoadAgent(false);

        }

        
    }


    async function desactive_account(data) {

        if(!refCheckBox.current.checked) {
            formError(refError, "Para desativar o agente você precisa aceitar nossos termos de uso.", true);
            return;
        }

        try {

            formError(refError, "", false);

            //processo de encerramento do agente
            setLoadAgent(true);
            refButton.current.innerHTML = "AGUARDE ...";

            let aid = basic.agent.id;
            let uid = basic.client.id;
            let dta = new Date();
            
            const billingsdb = collection(db, "billings");
            const billingsquery = query(billingsdb, where("id_agent", "==", aid), limit(1));
            
            const billingsdoc = await getDocs(billingsquery);

            let ids = billingsdoc.docs[0].data().id_subscription_asaas;

            const billingsref = doc(db, "billings", billingsdoc.docs[0].id);

            //exclui a assinatura
            const resCancellAsaas = await fetch("https://asaas-service-712108985873.southamerica-east1.run.app/cancellsubscription", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    assinatura: ids
                })
            });
                    
            if(!resCancellAsaas.ok) {

                const errorData = await resCancellAsaas.json();
                formError(refError, JSON.stringify(errorData), true);
                return;    

            } 

            //atualiza billing
            const billingsupdate = await updateDoc(billingsref, {status: "CANCEL", data_encerramento: dta});

            //atualiza agent
            const agentRef = doc(db, "agent", aid);

            await runTransaction(db, async (transaction) => {

                const agentSnap = await transaction.get(agentRef);

                const agentAtual = agentSnap.data();
                const agora = new Date();

                //1. salva histórico
                const histRef = doc(collection(db, "agent_hist"));

                transaction.set(histRef, {
                    ...agentAtual,
                    id_agent: aid,
                    data_inicio_vigencia: agentAtual.data_atualizacao,
                    data_fim_vigencia: agora,
                    archived_at: serverTimestamp()
                });

                //2. atualiza documento principal
                transaction.update(agentRef, {
                    status: 5,
                    data_atualizacao: agora,
                    data_termino_ativacao: agora,
                    status_motivo: "desativação a pedido do cliente"
                });

            });
            
            //atualiza medical
            const medicaldb = collection(db, "medical");
            const medicalquery = query(medicaldb, where("id_agent", "==", aid), limit(1));

            const medicaldoc = await getDocs(medicalquery);
            const medicalid = medicaldoc.docs[0].id;

            const medicalRef = doc(db, "medical", medicalid);

            await runTransaction(db, async (transaction) => {

                const medicalSnap = await transaction.get(medicalRef);

                const medicalAtual = medicalSnap.data();
                const agora = new Date();

                //1. salva histórico
                const histRef = doc(collection(db, "medical_hist"));

                transaction.set(histRef, {
                    ...medicalAtual,
                    data_inicio_vigencia: medicalAtual.data_atualizacao,
                    data_fim_vigencia: agora,
                    archived_at: serverTimestamp()
                });

                //2. atualiza documento principal
                transaction.update(medicalRef, {
                    data_atualizacao: agora,
                    data_encerramento: agora
                });

            });
  
            //atualiza uses 
            const usesquery = query(collection(db, "uses"), where("id_agent", "==", aid));
            const usesdados = await getDocs(usesquery);

            const usesref = doc(db, "uses", usesdados.docs[0].id);
            const usesupdate = await updateDoc(usesref, {data_termino_vigencia: dta});

            let tel = usesdados.docs[0].data().id_telephone;

            //atualiza telephones
            const telephonesref = doc(db, "telephones", tel);

            const telephonessnap = await getDoc(telephonesref);

            const id_gptmaker = telephonessnap.data().id_gptmaker;
            const tl_gptmaker = telephonessnap.data().telefone;

            const telephonesupdate = await updateDoc(telephonesref, {status: 1});

            //limpa o agente
            const resCancelAgent = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/agent/empty", 
            { method: "POST", headers: {"Content-Type": "application/json"} ,
                body: JSON.stringify(
                {
                    id: id_gptmaker,
                    telefone: tl_gptmaker
                })
            });
                    
            if(!resCancelAgent.ok) {

                const errorData = await resCancelAgent.json();
                formError(refError, JSON.stringify(errorData), true);
                return;    

            } 

            //limpa a agenda
            limpar_agenda(aid);

            registerLog(uid, "/cancell_subscription");
            
            setLoadAgent(false);

            setStep(3);
            window.scrollTo(0, 0);
            
        }
        catch(erro) {
            formError(refError, erro, true);
        }
        finally {
            refButton.current.innerHTML = "DESATIVAR";
            setLoadAgent(false);
        }
        
    }



    async function limpar_agenda(id_agent) {

        const diasRef = collection(db, "calendar", id_agent, "dias");
        const diasSnap = await getDocs(diasRef);

        if(diasSnap.empty) return;

        for(const diaDoc of diasSnap.docs) {

            const diaId = diaDoc.id;
            const diaData = diaDoc.data();
            const horarios = diaData.horarios || {};

            //filtra apenas horários ocupados
            const horariosOcupados = Object.entries(horarios).filter(([_, slot]) => slot?.status === "ocupado").reduce((acc, [hora, slot]) => {
                acc[hora] = slot;
                return acc;
            }, {});

            const diaRef = doc(db, "calendar", id_agent, "dias", diaId);

            //se não houver nenhum ocupado → apaga o dia inteiro
            if(Object.keys(horariosOcupados).length === 0) {
                await deleteDoc(diaRef);
                continue;
            }

            //se houver ocupados → mantém apenas eles
            await setDoc(diaRef, {horarios: horariosOcupados, updated_at: new Date()});

        }

    }




    function agent_back() {
        setStep(0);
    }



    function panel() {
        navigate("/panel");
    }

  

    function seleciona_plano(iid, pid, dic) {

        let itt = plans.length;

        for(let i = 0; i < itt; i++) { refPlanos[i].current.style.backgroundColor = ""; }

        switch(iid) {
        case 1: 
            if(itt === 1) {
                refPlanos[iid - 1].current.style.borderRadius = "10px 10px 10px 10px";
            } else {
                refPlanos[iid - 1].current.style.borderRadius = "10px 10px 0px 0px";
            }
            break;

        case itt:
            refPlanos[iid - 1].current.style.borderRadius = "0px 0px 10px 10px";
            break;

        default:
            refPlanos[iid - 1].current.style.borderRadius = "0px 0px 0px 0px";
        }
        
        refPlanos[iid - 1].current.style.backgroundColor = "yellow";
        setSelPlan({id: iid, codigo_plano: pid, id_plano: dic});

        refErroPlano.current.innerHTML = "";
        refErroPlano.current.style.height = "0";
        setError(0);
        
    }
    

    
    function agents_contents() {

        switch(selPlan.codigo_plano.substring(0, 3)) {
            case "CMD":
                navigate("/medical");
                break;
            case "EST":
                navigate("/aesthetic");
                break;
        }

    }


    function accept_terms() {

        if(refCheckBox.current.checked) {
            formError(refError, "", false);
        }

    }


    function Pesquisa({acao, setAcao}) {

        async function salvarPesquisa() {
    
            let aid = basic.agent.id;
            let uid = basic.client.id;
            let dta = new Date();

            let com = getValues("comentarios");
            let motivos = getValues("motivos");

            try {
            
                const docresearch = await addDoc(collection(db, "research"), { 
                    id_client: uid,
                    id_agent: aid,
                    data_atualizacao: dta,
                    motivos: motivos,
                    comentarios: com,
                });

                registerLog(uid, "/research/id=" + uid);

                setAcao("done");

            }
            catch(erro) {
                console.log(erro);
            }
        }

        if (acao === "done") {
            return (<div className="agent_research_success">Obrigado pelo feedback!<br />Vamos trabalhar sempre para melhorar nossos serviços</div>);
        }

        return (
            <>
            <div className="border_form agent_research_form">
                <form className="form">
                    <span className="title_form">Pesquisa de Satisfação</span>
                    <div className="agent_research_space"></div>
                    <span className="subtitle_form">Selecione todos os fatores que contribuíram para sua decisão:</span>
                    <div className="agent_research_item">
                        <input type="checkbox" className="checkbox_default" value="nao_funcionou" {...register("motivos")}></input>
                        <span className="agent_research_text">&nbsp;O agente não funcionou como eu esperava.</span>
                    </div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_item">
                        <input type="checkbox" className="checkbox_default" value="valor_assinatura" {...register("motivos")}></input>
                        <span className="agent_research_text">&nbsp;O valor de assinatura está muito alto.</span>
                    </div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_item">
                        <input type="checkbox" className="checkbox_default" value="concorrencia" {...register("motivos")}></input>
                        <span className="agent_research_text">&nbsp;Tem produto melhor na concorrência.</span>
                    </div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_item">
                        <input type="checkbox" className="checkbox_default" value="problema_mensalidade" {...register("motivos")}></input>
                        <span className="agent_research_text">&nbsp;Tive problemas com o pagamento das mensalidades.</span>
                    </div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_item">
                        <input type="checkbox" className="checkbox_default" value="suporte_winners" {...register("motivos")}></input>
                        <span className="agent_research_text">&nbsp;A Winners-ai não prestou o suporte devido.</span>
                    </div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_space"></div>
                    <label for="inp2" className="inp2">
                    <textarea placeholder="&nbsp;" {...register("comentarios")} maxLength={400}></textarea>
                    <span class="label2">Caso queira registrar algum comentário</span>
                    <span class="focus-bg2"></span>
                    </label>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_space"></div>
                    <div className="agent_research_space"></div>
                    <button type="button" className="button_form" onClick={salvarPesquisa}>RESPONDER</button>
                </form>
            </div>
            </>
        );
    }




    return(
        
        <div className="context">

            <Header access={1}></Header>

            <div className="content">

            { step === 0 && (
            <>
            
            { loadBasic ? (
            <>
            <div className="border_form agent_border_form">
                <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
            </div>
            </>
            ) : (
            <>
                { (basic?.agent?.status === 0 || basic?.agent?.status > 4) && (
                <>
                <div className="ft_topico">Crie seu agente</div>
                <div className="ft_descricao">Essas são as configurações básicas para a criação do seu agente, onde você lhe dará um nome e escolherá um plano que mais se adequa as suas necessidades.</div>
                <div className="space"></div>

                <div className="border_form agent_border_form">
                <form className="form" onSubmit={handleSubmit(create_agent)}>
                    <span className="title_form">Nome do agente</span>
                    <span className="subtitle_form">Defina um nome para seu agente, ele será usado para interagir com os seus clientes.</span>

                    <span ref={refErrorAgente} className="error_form"></span>
                    <label for="inp" className="inp" ref={refLabelAgente}>
                    <input type="text" placeholder="&nbsp;" maxLength={12} {...register("agente")} ref={(el) => {refAgente.current = el; register("agente").ref(el);}} onClick={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} onChange={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)}></input>
                    <span className="label">Nome do agente</span>
                    <span className="focus-bg"></span>
                    </label>

                    <span className="space_form"></span>
                    <span className="title_form">Escolha um plano</span>
                    <span className="subtitle_form">Clique no plano para selecionar, cada agente poderá ter apenas um plano associado. Selecione o plano que melhor atende as suas necessidades.</span>

                    <span ref={refErroPlano} className="error_form"></span>
                    <div className="agent_plano_campos">
                        <span className="agent_plano_campos1">código</span>
                        <span className="agent_plano_campos2">segmento</span>
                        <span className="agent_plano_campos3">atendimento</span>
                        <span className="agent_plano_campos4">mensalidade</span>
                    </div>
                    <div className="agent_plano_frame">

                    { plans.map((item, index) => (
                    <>  
                        <div ref={refPlanos[index]} className="agent_plano_item" onClick={() => basic.agent.status !== 2 && basic.agent.status !== 3 && seleciona_plano(index + 1, item.codigo, item.id )} style={{backgroundColor: selPlan.id === index + 1 ? "yellow" : "", cursor: basic.agent.status === 2 || basic.agent.status === 3 ? "" : "pointer", borderRadius: selPlan.id === 1 ? plans.length === 1 ? "10px 10px 10px 10px" : "10px 10px 0px 0px" : selPlan.id === plans.length ? "0px 0px 10px 10px" : "0px 0px 0px 0px"}}>
                            <span className="agent_plano_item1">{ item.codigo }</span>
                            <span className="agent_plano_item2">{ item.ramo }</span>
                            { item.atendimento === "W" ? (<><span className="agent_plano_item3"><img className="agent_image_whats" src={icon_whats}></img></span></>) : (<><span className="agent_plano_item3"><img className="agent_image_whats" src={icon_whats}></img>&nbsp;<img className="agent_image_whats" src={icon_web}></img></span></>) }
                            <span className="agent_plano_item4">grátis por 7 dias</span>
                        </div>
                    
                        { index + 1 < plans.length && (
                            <>
                            <div className="agent_plano_line">
                                <div className="agent_plano_lineitem"></div>
                            </div>  
                            </>
                        )}
                    </>
                    ))}
                    </div>
                    <span className="agent_aviso_mensalidade">* a mensalidade só é cobrada caso você opte em assinar o serviço</span>

                    <span className="space_form"></span>
                    <span className="title_form">Ativação Imediata</span>
                    <span className="subtitle_form">Pode ocorrer, eventualmente, uma alta demanda na crição de agentes e a ativação do seu agente não ocorra imediatamente.</span>

                    <label for="inp" className="inp">
                    <input type="text" placeholder="&nbsp;" disabled value={disponiveis === 0 ? "Aguardar ativação" : "Ativação imediata"}></input>
                    <span className="label">Status atual</span>
                    <span className="focus-bg"></span>
                    </label>

                    <span className="space_form"></span>
                    <span ref={refError} className="error_form"></span>
                    <span className="space_form"></span>

                    <button type="button" name="bt1a" ref={refButton} className={loadAgent ? "button_disabled_form" : "button_form"} onClick={create_agent} disabled={loadAgent}>CRIAR AGENTE</button>
                </form>
                </div>
                </>
                )}                    

                { basic?.agent?.status === 1 && (
                <>
                
                </>
                )}

                { basic?.agent?.status === 2 && (
                <>
                <div className="ft_topico">Agente Configurado</div>
                <div className="ft_descricao">Seu agente foi configurado, entretanto, estamos com uma alta demanda e em breve ativaremos o seu agente.</div>
                <span className="space_form"></span>
                
                <div className="border_form agent_border_form">
                <form className="form">
                    <span className="title_form">Nome do agente</span>
                    
                    <label for="inp" className="inp">
                    <input type="text" placeholder="&nbsp;" maxLength={12} disabled value={basic.agent.nome}></input>
                    <span className="label">Nome do agente</span>
                    <span className="focus-bg"></span>
                    </label>

                    <span className="space_form"></span>

                    <span className="title_form">Plano</span>
                    
                    <label for="inp" className="inp">
                    <input type="text" placeholder="&nbsp;" maxLength={12} disabled value={basic.agent.plano + " - " + descPlano}></input>
                    <span className="label">Plano do agente</span>
                    <span className="focus-bg"></span>
                    </label>

                    <span className="space_form"></span>

                    <span className="title_form">Status</span>
                    
                    <label for="inp" className="inp">
                    <input type="text" placeholder="&nbsp;" maxLength={12} disabled value={"Aguardando alocação de linha"}></input>
                    <span className="label">Status do agente</span>
                    <span className="focus-bg"></span>
                    </label>

                </form>
                </div>

                </>
                )}

                { basic?.agent?.status === 4 && (
                <>
                <div className="ft_topico">Altere seu agente</div>
                <div className="ft_descricao">Aqui você pode alterar seu agente e suas respectivas configurações.</div>
                <div className="space"></div>

                    { isPending ? (
                    <>
                    <div className="border_form agent_border_form">
                        <span ref={refLoad} className="load_form">aguarde carregando formulário ...</span>
                    </div>
                    </>
                    ) : (
                    <>
                    <div className="border_form agent_border_form">
                        <form className="form" onSubmit={handleSubmit(update_agent)}>
                            <span className="title_form">Alteração do agente</span>

                            <span ref={refErrorAgente} className="error_form"></span>
                            <label for="inp" className="inp" ref={refLabelAgente}>
                            <input type="text" placeholder="&nbsp;" maxLength={12} {...register("agente")} ref={(el) => {refAgente.current = el; register("agente").ref(el);}} onClick={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)} onChange={() => clearError(refAgente, refLabelAgente, refErrorAgente, error, setError)}></input>
                            <span className="label">Nome do agente</span>
                            <span className="focus-bg"></span>
                            </label>

                            <span className="space_form"></span>
                            <span ref={refErroAgente} className="error_form"></span>
                            <span className="space_form"></span>

                            <div className="agent_box_buttons">
                                <div className="agent_box_buttons_1a"><button type="button" name="bt4a" ref={refNomeButton} className={loadAgent ? "button_disabled_form" : "button2_form"} onClick={update_agent} disabled={loadAgent}>ALTERAR NOME</button></div>
                                <div className="agent_box_buttons_1b"></div>
                                <div className="agent_box_buttons_1c"><button type="button" name="bt4b" ref={refButton} className="button_form" onClick={agents_contents}>ALTERAR CONFIGURAÇÕES</button></div>
                            </div>

                        </form>
                    </div>
                    </>
                    )}
                </>
                )}
            </>)}

            </>
            )}
            
            
            { step === 1 && (
            <>
            <div className="ft_topico">Agente criado</div>
            <div className="ft_descricao">Parabéns, seu agente <span className="agent_success_01">{getValues("agente")}</span> está criado!</div>
            <div className="space"></div>
            <img className="agent_image" src={icon_success}></img>
            <div className="space"></div>
            <span className="agent_success_02">Caso queira configurar seu agente agora, clique no botão abaixo</span>
            <span className="agent_success_03">*você pode configurá-lo em outro momento, se preferir</span>
            <div className="space"></div>
            <div className="agent_box_button">
                <button type="button" name="btF" className="button_form" onClick={agents_contents}>CONFIGURAR AGENTE</button>
            </div>
            
            </>
            )}


            { step === 2 && (
            <>
            <div className="ft_topico">Desativar agente</div>
            <div className="ft_descricao">Desativa o agente e encerra a assinatura.</div>
            <div className="space"></div>

            <div className="border_form agent_border_form">
                <form className="form" onSubmit={handleSubmit(desactive_account)}>
                    <span className="title_form">Desativar</span>
                    <span className="agent_descricao">Desativando seu agente, sua assinatura conosco será encerrada, seu agente irá parar de funcionar em até vinte e quatro horas e todo histórico será perdido.</span>
                    <span className="agent_descricao">É imprescindível também informar que o número da linha de seu agente será disponibilizado a outro cliente e não será mais possível reaver esse mesmo número.</span>
                    <span className="agent_descricao">Todas as suas futuras mensalidades serão canceladas a partir desse momento, conforme nossos Termos de Uso.</span>
                    <span className="space_form"></span>
                    <div className="agent_terms">
                        <input type="checkbox" className="checkbox_default" ref={refCheckBox} onClick={accept_terms}></input>
                        <a href="/terms" className="agent_terms_text" target="_blank" rel="noopener noreferrer">Estou ciente conforme os termos de uso.</a>
                    </div>
                    <span className="space_form"></span>
                    <span ref={refError} className="error_form"></span>
                    <span className="space_form"></span>
                    <button type="submit" ref={refButton} name="bt3b" className={loadAgent ? "button_disabled_form" : "button_form"} disabled={loadAgent}>DESATIVAR</button>                    
                </form>
            </div>
            </>
            )}

            { step === 3 && (
            <>
            <div className="ft_topico">Agente desativado</div>
            <div className="ft_descricao">Seu agente foi desativado com sucesso.</div>
            <div className="space"></div>
            <img className="agent_image_atebreve" src={icon_atebreve}></img>
            <div className="space"></div>
            <span className="agent_success_02">{firstName(basic.client.responsavel)},</span>
            <span className="agent_success_02">Foi muito bom ter você como cliente!</span>
            <span className="agent_success_04">Você nos ajudaria muito se pudesse responder nossa rápida pesquisa para entender o motivo<br />do seu cancelamento para sempre melhorarmos nossos serviços</span>
            <div className="space"></div>
            <Pesquisa acao={acaoPesquisa} setAcao={setAcaoPesquisa} />
            </>
            )}


            { step === 4 && (
            <>
            <div className="ft_topico">Agente alterado</div>
            <div className="ft_descricao">O nome do seu agente foi alterado com sucesso.</div>
            <div className="space"></div>
            <img className="agent_image" src={icon_success}></img>
            <div className="space"></div>
            <span className="agent_success_02">Caso querira configurar seu agente agora, clique no botão abaixo</span>
            <span className="agent_success_03">*você pode configurá-lo em outro momento, se preferir</span>
            <div className="space"></div>
            
            </>
            )}

            <div className="space"></div>
            <div className="space"></div>
            <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
            <div className="space"></div>
            <div className="space"></div>

            </div>

            <Footer access={1}></Footer>

        </div>

    )
}